import React from "react";
import { Link } from "react-router-dom";
import { useState } from "react"


export default function Skill() {
    return (
        <>
            <section className="skill-1-section section-padding half-bg">
                <div className="auto-container full-width">
                    <div className="row align-items-center">                
                        <div className="col-lg-6 order-lg-2 ps-lg-5">
                            <div className="skill-1-inner-container p_relative">
                                <div className="section_heading mb_30">
                                    <span className="section_heading_title_small" style={{fontSize : 20, fontWeight : '600'}}>With Us, <span style={{fontWeight : '800',fontSize : 23,color : '#6E3F98'}}>YOU</span>  Come First</span>
                                    <h2 className="section_heading_title_big">Most <span>Experienced NDIS</span> Care <br />
                                        </h2>
                                </div>
                                <div className="skill-1-text">We are a staunch provider of exceptional disability support services for NDIS participants. From the thriving cosmopolitan of Perth, Western Australia, we bring to you a person-centered disability support service that is completely focused on making your life easier, fairer and more involved in the society. What we want is to help you step into a life, home and community that witnesses your golden years. </div>
                                {/* <div className="skill-1-progressbar-item">
                                    <p className="skill-1-progressbar-title">NDIS Care</p>
                                    <div className="progressbar-1-outer">
                                        <div className="progressbar-2-inner progress-line" data-width="100">
                                            <div className="progressbar-1-percentage"><div className="count-box"></div></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="skill-1-progressbar-item">
                                    <p className="skill-1-progressbar-title">Home Nursing</p>
                                    <div className="progressbar-1-outer">
                                        <div className="progressbar-3-inner progress-line" data-width="90">
                                            <div className="progressbar-1-percentage"><div className="count-box"><span className="count-text" data-speed="2000" data-stop="90">90</span>%</div></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="skill-1-progressbar-item">
                                    <p className="skill-1-progressbar-title">Food & Health</p>
                                    <div className="progressbar-1-outer">
                                        <div className="progressbar-4-inner progress-line" data-width="80">
                                            <div className="progressbar-1-percentage"><div className="count-box"><span className="count-text" data-speed="2000" data-stop="80">80</span>%</div></div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-6 ps-0 pe-lg-5">
                            <div className="skill-1-image-wrap">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="skill-1-image2 mb_30"><img src="assets/images/resource/drinking.jpg" alt="" style={{borderRadius: "18%",marginLeft : '10px'}}/></div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="skill-1-image2 mb_30"><img src="assets/images/resource/ndis6.webp" alt="" style={{borderRadius: "18%"}}/></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
